import styled from 'styled-components';

export const RadioWrapper = styled.div`
  > * {
    margin-bottom: 16px;
  }
`;
